import * as React from 'react';
import './custom.js';
import {
  UserOutlined,
  InstagramFilled,
  FacebookFilled,
  LinkedinFilled,
} from '@ant-design/icons';
import {Suspense, useEffect, useState} from 'react';

import {
  Layout,
  Typography,
  Skeleton,
  Select,
  Image,
  Menu,
  Avatar,
  Row,
  Col, notification,
} from 'antd';
import {
  PlusOutlined,
  MinusOutlined,
} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';

import LoaderOverlay from 'shared/components/LoaderOverlay';

import './Layout.scss';
import {NavLink, useHistory} from 'react-router-dom';
import {AuthConsumer} from '../../contexts/AuthContext';
import {useLocation} from 'react-use';
import Parameters from 'shared/parameters';
import API_SERVICE from '../../services/api-service';
import Humberger from '../../../client/src/img/humburger.png';

const {Header, Sider, Content} = Layout;
const {Text} = Typography;

export default function DesktopAdminLayout({
                                             children,
                                           }: any) {
  const settings = JSON.parse(localStorage.getItem('settings') as string);
  const {t, i18n} = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('/organizations' as string);
  const [loading, setLoading] = useState(true);
  const currentLanguage = localStorage.getItem('language') || Parameters.DefaultLang

  useEffect(() => {
    if (Parameters.Mode === 'ADMIN') {
      API_SERVICE.fetchSettings().then((settings) => {
        localStorage.setItem('settings', JSON.stringify(settings.data.data));
        setLoading(false);
      }).catch((e) => {
        notification.error({
          message: API_SERVICE.handleErrors(e),
        });
      });
    } else {
      setLoading(false);
    }
    if (location.pathname)
      setActiveTab(location.pathname);

    // let link = document.querySelector('link[rel~=\'icon\']');
    // if (!link) {
    //   link = document.createElement('link');
    //   // @ts-ignore
    //   link.rel = 'icon';
    //   document.getElementsByTagName('head')[0].appendChild(link);
    // }
    // // @ts-ignore
    // link.href = Parameters.ImageBaseUrl + settings.logo.slug + settings.logo.ext;
  }, [location]);

  const handleClick = (e: any) => {
    history.push(e.key);
    return true;
  };
  if (loading) {
    return <Skeleton/>
  }
  return (
    <AuthConsumer>
      {({isAuth, updateCart, cartTime, cart, user}) => (
        <Layout
          style={{minHeight: '100vh'}}
          className={`desktop-layout`}>
          
          <Layout>
            <Sider className={'admin sider-wrapper'} width={256} theme={'dark'}>
              <div className='menu-wrapper'>
              <nav className="navbar" style={{padding:'0'}}>

                  <ul className="navbar-nav w-100">
                    <li className='nav-item text-center bg-white'>
                      <div className='custom-nav-link'>
                        <NavLink to={'/'}>
                          <Image
                            preview={false}
                            className={'logo'}
                            src={Parameters.ImageBaseUrl + settings.logo.slug + settings.logo.ext}
                            style={{maxWidth: '100%'}}/>
                        </NavLink>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div className="dropdown side-dropdown">
                        <a type='button' className="open-dropdown text-white">
                          {t('genDict.admin')}
                          <PlusOutlined className='plus text-white' />
                          <MinusOutlined className='minus text-white' />
                        </a>
                        <div className="dropdown-menu">
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/student');
                          }}>{t('genDict.students')}
                          </a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/instructor');
                          }}>{t('genDict.instructors')}</a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/badges');
                          }}>{t('genDict.badges')}</a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/banners');
                          }}>{t('genDict.banners')}</a>
                          {/* <a className="dropdown-item text-white" href="/packages">{t('genDict.packages')}</a> */}
                          {/* <a className="dropdown-item text-white" href="/static-pages">{t('genDict.staticPages')}</a> */}
                        </div>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div className="dropdown side-dropdown">
                        <a type='button' className="open-dropdown text-white">
                          {t('genDict.content')}
                          <PlusOutlined className='plus text-white' />
                          <MinusOutlined className='minus text-white' />
                        </a>
                        <div className="dropdown-menu">
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/reviews');
                          }}>{t('genDict.reviews')}
                          </a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/instructor-ratings');
                          }}>{t('genDict.instructorRatings')}
                          </a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/categories');
                          }}>{t('genDict.categories')}</a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/levels');
                          }}>{t('genDict.levels')}</a>
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/courses');
                          }}>{t('genDict.courses')}</a>
                        </div>
                      </div>
                    </li>
                    <li className="nav-item">
                      <div className="dropdown side-dropdown"><a type='button' className=" open-dropdown dropdown-item text-white" onClick={()=>{
                            history.push('/training-schedule');
                          }}>
                        {t('genDict.trainingSchedule')}
                      </a></div>
                    </li>
                    <li className="nav-item">
                      <div className="dropdown side-dropdown">
                        <a type='button' className="open-dropdown text-white">
                          {t('genDict.reports')}
                          <PlusOutlined className='plus text-white' />
                          <MinusOutlined className='minus text-white' />
                        </a>
                        <div className="dropdown-menu">
                          {/* <a className="dropdown-item text-white" 
                          onClick={()=>{
                            history.push('/reports/orders');
                          }}>{t('genDict.ordersReport')}</a> */}

                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/reports/instructors');
                          }}>{t('genDict.instructorsReport')}</a>
                          
                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/reports/students');
                          }}>{t('genDict.studentsReport')}</a>

                          {/* <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/reports/learners');
                          }}>{t('genDict.learnersReport')}</a> */}

                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/reports/courses');
                          }}>{t('genDict.coursesReport')}</a>

                          <a className="dropdown-item text-white" onClick={()=>{
                            history.push('/reports/questions');
                          }}>{t('genDict.wrongQuestionReport')}</a>
                        </div>
                      </div>
                    </li>
                  </ul>

                </nav>
              </div>
            </Sider>

            <Content className={'content-layout'}>
            <Header>
            <Row gutter={20} align={'middle'}>
              <Col flex={'auto'}>
                <Row gutter={20}>
                  <div className='d-flex'>
                    <div className='humburger'>
                      <img className="sidebar-toggle" src={Humberger} style={{width:'35px'}}/>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col>
                <Row>
                  {/* <Col>
                    <div className='custom-nav-link'>
                      <Select value={currentLanguage} onChange={(e) => {
                        localStorage.setItem('language', e);
                        i18n.changeLanguage(e);
                        window.location.reload();
                      }
                      }>
                        <Select.Option value={'en'}>English</Select.Option>
                        <Select.Option value={'de'}>German</Select.Option>
                        <Select.Option value={'ar'}>Arabic</Select.Option>
                      </Select>
                    </div>
                  </Col> */}
                  <Col>
                    {
                      user ? <>
                        <NavLink to={'/my/profile'} activeClassName='active-nav-link'>
                          <div className='custom-nav-link account-details'>
                            <Avatar size={30} icon={<UserOutlined/>}/>
                            <Text style={{marginTop: '4px'}}>{user.name}</Text>
                          </div>
                        </NavLink>
                      </> : <NavLink to={'/login'} activeClassName='active-nav-link'>
                        <div className='custom-nav-link'>
                          {t('genDict.login')}
                        </div>
                      </NavLink>
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </Header>
              <Suspense fallback={<LoaderOverlay size='large' loading={true}/>}>
                {children}
              </Suspense>
            </Content>
          </Layout>
          <div className='footer-wrapper'>
            <Row gutter={20} className={'secondary-footer'}>
              <Col flex={'auto'}>
                <NavLink to={'/pages/copyright'}><Text>{t('genDict.copyRight')}</Text></NavLink>
              </Col>
              <Col>
                <a target={'_blank'} href={'about-us'}><Text><InstagramFilled/></Text></a>
              </Col>
              <Col>
                <a target={'_blank'} href={'about-us'}><Text> <FacebookFilled/></Text></a>
              </Col>
              <Col>
                <a target={'_blank'} href={'about-us'}><Text> <LinkedinFilled/></Text></a>
              </Col>
              <Col>
                <NavLink to={'/pages/about'}><Text>{t('genDict.about')}</Text></NavLink>
              </Col>
              <Col>
                <NavLink to={'/pages/contact'}><Text>{t('genDict.contact')}</Text></NavLink>
              </Col>
              <Col>
                <NavLink to={'/pages/terms-of-use'}><Text>{t('genDict.termsOfUse')}</Text></NavLink>
              </Col>
              <Col>
                <NavLink
                  to={'/pages/privacy-policy'}><Text>{t('genDict.privacyPolicy')}</Text></NavLink>
              </Col>
            </Row>
          </div>
        </Layout>
      )
      }
    </AuthConsumer>
  );
}
